import React from "react";
import { useTranslation } from "react-i18next";

import { AddressFormModal } from "../../profile/components/AddressFormModal";

/**
 * A12: single-step admin address form. The A10-era owner-picker step
 * (and its users-list fetch + `usersError` surfacing) is retired — the
 * global address book has no owner scope; the backend picks up the
 * calling admin as `created_by` on the JWT.
 *
 * On EDIT the audit info line at the top of the modal shows the
 * original creator's name for context.
 *
 * Props:
 *   open, onOpenChange
 *   initial       — address dict (with `created_by_name`) or null for create
 *   onSubmit(payload)
 *   submitting
 */
export function AdminAddressFormModal({
  open,
  onOpenChange,
  initial,
  onSubmit,
  submitting,
}) {
  const { t } = useTranslation();
  const isEdit = Boolean(initial?.id);
  // A18 — creator tracking retired from UI. Backend also stops
  // populating created_by / created_by_name on new rows. Both fields
  // remain dormant on old rows.

  return (
    <AddressFormModal
      open={open}
      onOpenChange={onOpenChange}
      initial={initial || undefined}
      onSubmit={onSubmit}
      submitting={submitting}
    />
  );
}
